import users from "./users.routes";

export default [...users];
